const TUTORIAL_KEY = "discover_tutorial_active";
export const setTutorialActive = () => localStorage.setItem(TUTORIAL_KEY, "true");
export const isTutorialActive = () => localStorage.getItem(TUTORIAL_KEY) === "true";
export const clearTutorial = () => localStorage.removeItem(TUTORIAL_KEY);
